import { render, staticRenderFns } from "./CalculatorPersonalGain.vue?vue&type=template&id=06a015f7&scoped=true"
import script from "./CalculatorPersonalGain.vue?vue&type=script&lang=js"
export * from "./CalculatorPersonalGain.vue?vue&type=script&lang=js"
import style0 from "./CalculatorPersonalGain.vue?vue&type=style&index=0&id=06a015f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a015f7",
  null
  
)

export default component.exports